// extracted by mini-css-extract-plugin
export var brand = "_4u-9";
export var compact = "_4u-6";
export var extraSmall = "_4u-7";
export var icon = "_4u-0";
export var large = "_4u-4";
export var light = "_4u-1";
export var medium = "_4u-5";
export var outline = "_4u-b";
export var primaryDark = "_4u-a";
export var primaryLight = "_4u-8";
export var primaryModern = "_4u-c";
export var success = "_4u-2";
export var successSolid = "_4u-3";